var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 80",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "09-Profit",
    fill: "#ceb081",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,12a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0v8A1,1,0,0,0,50,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,12a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0v8A1,1,0,0,0,38,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,12a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0v8A1,1,0,0,0,26,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,12a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0v8A1,1,0,0,0,14,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,7H53v4a3,3,0,0,1-6,0V7H41v4a3,3,0,0,1-6,0V7H29v4a3,3,0,0,1-6,0V7H17v4a3,3,0,0,1-6,0V7H5a3,3,0,0,0-3,3v8H62V10A3,3,0,0,0,59,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,48v6h4V48Zm12-4V54h4V44Zm0,0V54h4V44ZM18,48v6h4V48ZM2,20V59a3,3,0,0,0,3,3H59a3,3,0,0,0,3-3V20ZM17.29,40.29l11-11a1,1,0,0,1,1.42,0L35,34.59,43.59,26H40a1,1,0,0,1,0-2h6a1,1,0,0,1,1,1v6a1,1,0,0,1-2,0V27.41l-9.29,9.3a1,1,0,0,1-1.42,0L29,31.41,18.71,41.71a1,1,0,0,1-1.42,0A1,1,0,0,1,17.29,40.29ZM24,55a1,1,0,0,1-1,1H17a1,1,0,0,1-1-1V47a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm12,0a1,1,0,0,1-1,1H29a1,1,0,0,1-1-1V43a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm12,0a1,1,0,0,1-1,1H41a1,1,0,0,1-1-1V39a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1Zm-6-1h4V40H42ZM30,54h4V44H30ZM18,54h4V48H18ZM30,44V54h4V44Zm0,0V54h4V44Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmc);
export default __webpack_public_path__ + "static/media/amc.c4a6a0f8ce593e37d8e54f4ab56e7acc.svg";
export { ForwardRef as ReactComponent };